<template>
  <div class="contentArea">
    <AgGrid />
    <span class="flex justify-end"
      ><p>
        <b>หมายเหตุ***</b>
        หากต้องการ<b>ลบประเภทของผู้เรียน&nbsp;</b>กรุณาตรวจสอบให้แน่ใจว่า<b
          >ประเภทผู้เรียนนั้นไม่มีอยู่ในประเภทหลักสูตร</b
        >
      </p></span
    >
  </div>
</template>

<script>
import AgGrid from "../elements/ag-grid-table/AgGridTable.vue";
import { mapGetters } from "vuex";
export default {
  ...mapGetters({
    nowSlug: "getNowSlug",
    tabActive: "general/tabActive",
    page: "general/page"
  }),
  components: {
    AgGrid
  },

  mounted() {
    this.$store.dispatch("general/getOrganization");
    this.$store.dispatch("general/push_pointer", "organization");
  }
};
</script>

<style lang="scss" scoped></style>
